<template>
		<div style="background-color:#F5F5F5;width:100%;">
			<!-- 主文 -->
			<div style="display:flex;justify-content: center;">
			<div style="background-color:#F5F5F5;display:flex;margin-top:10px;">
				<!-- 2 -->
				<div style="background-color:white;margin-left:14px;width:948px; padding-top:14px;">
					<div >
						<div style="display:flex;border-bottom:#EEEEEE 1px solid;margin:0px 14px;">
							<div class="font" v-for="(item,index) in zxa" :key="index"  @click="changes(index)">
								<div :class="(index==0?'bjmagins':'bjmagin')" class="zxfont" :style="index!=tabIndexs?'color:#C5C5C5;':'border-bottom:3px solid;border-image:linear-gradient(to right,#5AD6CE,#38A5EC) 5 5;'">{{item.name}}</div>
							</div>
						</div>
						<div style="display: flex;flex-wrap:wrap;margin:0px 14px;padding-bottom:60px;">
							<div v-for="(item,index) in zp" :key="index" style="margin-top: 30px;">
								<div >
									<a v-if="item.src!=''" :href="item.src" target="_blank"><img :class="(index%4==0?'imgs':'img')" :src="urls+item.url" /></a>
									<img v-else :class="(index%4==0?'imgs':'img')" :src="urls+item.url" @click="towz(item.id)" />
									<div style="width:170px;font-size:14px;" :style="(index%4==0?'':'margin-left:73px;')">{{item.title}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			</div>
		</div>
</template>

<script>
	import axios from '../util/http.js'
	import base from '../util/base.js'
	export default {
		name:"meeting",
		components:{
		},
		data() {
			return {
				url:'https://www.baidu.com/',
				tabIndexs:0,
				tabIndexb:0,
				zp:[],
				zps:'',
				zx:'',
				urls:'',
				id:'',//进入id
				pid:'',//发生变化的id
				zps:[],
				zxa:'',
				zxb:'',
				zxs:'',
				length:'',
			}
		},
		created() {
			//获取活动分类接口
			axios({
				urls:'',
			    url: `${base.url}/api/user/shaky_one`,
			    method: 'post',
			    data:''
			}).then((res) => {
				this.zx=res.data.slice(0,1)
				this.zxs=res.data.slice(1,2)
				this.zxa=this.zx[0]
				this.zxb=this.zxs[0]
				this.urls=res.url
				this.length=this.zxa.length+1
				this.oupen(this.zxa[0].id)
				this.oupenb(this.length)
			        })
		},
		methods: {
		towz(e){
			console.log(e);
			this.$router.push({path:'/Home/details',query:{data:e,datas:11}});
		},
		changes:function(e){
			this.tabIndexs=e
			this.oupen(this.zxa[e].id)
		},
		changeb:function(e){
				this.tabIndexb=e
				this.oupenb(this.zxb[e].id)
		},
		oupen:function(e){
			this.pid=e
			// console.log(this.pid);
			//获取活动文章
			axios({
			    url: `${base.url}/api/user/shaky`,
			    method: 'post',
			    data:{pid:this.pid}
			}).then((res) => {
				this.zp=res.data
				// console.log(this.zp);
			        })
		},
		oupenb:function(e){
			this.id=e
			//获取活动文章
			axios({
			    url: `${base.url}/api/user/shaky`,
			    method: 'post',
			    data:{pid:this.id}
			}).then((res) => {
				this.zps=res.data
			        })
		}
		},
	}
</script>

<style lang="scss" scoped>
	.zxfont{
		font-weight:600;
		padding-bottom:5px;
	}
	.zxfont:hover{
	 color:#767676 !important;
	 cursor:pointer;
	 }
	.bjmagin{
		margin:0px 10px 0px;
	}
	.bjmagins{
		margin:0px 10px 0px 0px;
	}
	.img{
		width: 174px;
		height: 119px;
		margin-left:73px;
		cursor:pointer;
	}
	.imgs{
		width: 174px;
		height: 119px;
		cursor:pointer;
	}
	.flex{
		display:flex;
	}
	.flexjust{
		justify-content: center;
	}
	.flexali{
		align-items: center;
	}
	.colorwhite{
		color: #FFFFFF;
	}
	.activeb{
		background-color:#B5B5B5 !important;
	}
	.activec{
		background-color:#E27265 !important;
	}
	.dhl{
		color:#FFFFFF;
		font-size:15px;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.dhls{
		color:#FFFFFF;
		font-size:15px;
		background-color: #59D4CF;
		display:flex;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.Line{
		width:1px;
		height: 14px;
		background-color:#FFFFFF;
	}
	.kes{
		font-size: 14px;
		margin-left:2px;
		margin-top:5px ;
		color:#848484;
	}
	.Lines{
		width:1px;
		height: 12px;
		background-color:#CCCCCC;
		margin:10px 5px 10px;
	}
	.font{
		font-size:14px;
	}
	.font:hover{
		cursor:pointer;
	}
	.colortm{
		font-size: 12px;
		opacity:0.2;
	}
	.fontcolor{
		color:#767676;
	}
	.has{
		margin-top:5px;
		margin-left:10px;
	}
	.hass{
		margin-top:5px;
	}
	.mas{
		width:13px;
		height: 2px;
		background-color: #5AD6CE;
		margin-top:5px;
	}
	.hand{
		width:25px;
		height: 2px;
		background-color: #5AD6CE;
		margin-top:5px;
	}
	.hands{
		width:25px;
		height: 2px;
		background-color: #5AD6CE;
		margin-top:5px;
		margin-left:10px;
	}
	.mass{
		width:13px;
		height: 2px;
		background-color: #38A5EC;
		margin-top:5px;
	}
	.masr{
		width:13px;
		height: 2px;
		background-color: #5AD6CE;
		margin-top:5px;
		margin-left:10px;
	}
	.hove{
		margin:10px 2% 10px; 
		width:96%;
		background-color:#EEEEEE;
		height:2px;
	}
	.yerw{
		margin-left: 20px;
	}
	.por{
		display:flex;
		flex-direction: column;
		margin-left:10px;
	}
	.nmb{
		margin-top: 8px;
	}
	.bodya{
		background-color:#5AD6CE;
		width:100px;
		height:86.9px;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
	}
	.bodyb{
		background-color:#20919D;
		width:99px;
		height:86.9px;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
	}
	.bodyc{
		background-color:#5AD6CE;
		width:80px;
		height:70px;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
	}
	.bodyd{
		background-color:#20919D;
		width:80px;
		height:70px;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
	}
	.nvbc{
		background-color:#20919D;
		width: 94px;
		height: 116px;
	}
	.ggnm{
		width:298px;
		height:76px;
	}
	.iur{
		margin-left: 5px;
	}
	.bjtop{
		margin-top: 10px;
	}
	.bjleft{
		margin-left:10px;
	}
	.bjright{
		margin-right:10px;
	}
	.bjbottom{
		margin-bottom:10px;
	}
	.router-link-active {
	  text-decoration: none;
	}
	a {
	  text-decoration: none;
	}
</style>
